var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideo = function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "video_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".video_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9 15.8c-.5.2-1.1 0-1.3-.4-.1-.1-.1-.3-.1-.4V9.1c0-.6.4-1 1-1 .2 0 .3 0 .4.1l5.8 2.9c.5.2.7.8.4 1.3-.1.2-.3.3-.4.4z",
    className: "video_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2.5h15c2.2 0 4 1.8 4 4v11c0 2.2-1.8 4-4 4h-15c-2.2 0-4-1.8-4-4v-11c0-2.2 1.8-4 4-4",
    className: "video_svg__st0"
  })));
};
export default SvgVideo;